<template>
	<div class="home">
		<mv-map :mapConfig="mapConfig" @map-load="mapLoad"></mv-map>
	</div>
</template>

<script>
import geo from "../assets/gs_sjk.json"
export default {
	name: "Home",
	components: {},
	data(){
		return{
			mapConfig: {
                zoom: 6.5,
                center: [119.31125153515623, 32.81318586466233],
                theme: 'light'
            }
		}
	},methods:{
		mapLoad(map) {
			let arrResult=[],_this=this
			geo.map(item=>{
				arrResult.push({
						name: item['f_vc_roadnum'],
						path: JSON.parse(item['st_asgeojson']).coordinates[0],
						config: {
						  lineWidth: 2,
						  lineColor: '#5ECB8B',
						}
					})
			})
			this.$mapSdk().createMvMapMassLine(arrResult,{},(res)=>{
				console.log(res)
			})
			this.$mapSdk().createMvMapProvince({
				code: 320000,
				provinceOutside: {
					borderColor: '#6DA9EA',
					borderWeight: 4,
					fillColor:'#1a528e'
				}
			})
        }
	},
};
</script>
<style lang="less">
	.home{
		width: 100%;
		height: 100%;
	}
</style>
